import multiApiClient from "./base";

// ── Otto Articles ────────────────────────────────────────────────────────────
export const ottoItemsApi = {
  // Cron
  startCronJob: (
    schedule = "0 8 * * *",
    discord_webhook = null,
    sync = false,
  ) =>
    multiApiClient.post("/otto/articles/cron/start", null, {
      params: {
        schedule,
        ...(discord_webhook ? { discord_webhook } : {}),
        sync,
      },
    }),

  stopCronJob: () => multiApiClient.post("/otto/articles/cron/stop"),

  getCronStatus: () => multiApiClient.get("/otto/articles/cron/status"),

  // Sync from Otto API (add new active articles, remove inactive)
  syncFromOtto: (sku = null) =>
    multiApiClient.post("/otto/articles/sync_from_otto", null, {
      params: sku ? { sku } : {},
    }),

  // Sync daily SPA ad performance for an optional date range.
  syncAdsFromOtto: ({ sku, from_date, to_date } = {}) =>
    multiApiClient.post("/otto/articles/sync_ads_from_otto", null, {
      params: {
        ...(sku ? { sku } : {}),
        ...(from_date ? { from_date } : {}),
        ...(to_date ? { to_date } : {}),
      },
    }),

  // Monitor prices (manual trigger)
  monitorItems: (
    sku = null,
    webhook = null,
    stepSize = null,
    keepBuyBox = false,
  ) =>
    multiApiClient.post(
      `/otto/articles/monitor/${sku ? encodeURIComponent(sku) : "all"}`,
      null,
      {
        params: {
          ...(webhook ? { webhook } : {}),
          ...(stepSize != null && stepSize !== ""
            ? { step_size: stepSize }
            : {}),
          ...(keepBuyBox ? { keep_buy_box: true } : {}),
        },
      },
    ),

  // Recalculate prices
  recalculate: (sku = "") => {
    const path = sku
      ? `/otto/articles/recalculate/${encodeURIComponent(sku)}`
      : `/otto/articles/recalculate`;
    return multiApiClient.post(path);
  },

  // XLSX management
  uploadXlsx: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return multiApiClient.post("/otto/articles/upload-xlsx", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getXlsxContent: (filename = "data.xlsx") =>
    multiApiClient.get("/otto/articles/xlsx-content", {
      params: { filename },
    }),

  checkXlsxExists: (filename = "data.xlsx") =>
    multiApiClient.get("/otto/articles/xlsx-exists", {
      params: { filename },
    }),

  downloadXlsx: (filename = "data.xlsx") =>
    multiApiClient.get("/otto/articles/download-xlsx", {
      params: { filename },
      responseType: "blob",
    }),

  // Workflow result
  checkWorkflowResultExists: () =>
    multiApiClient.get("/otto/articles/workflow-result-exists"),

  downloadWorkflowResult: () =>
    multiApiClient.get("/otto/articles/download-workflow-result", {
      responseType: "blob",
    }),
};

// ── Otto Pricing History ─────────────────────────────────────────────────────
export const OttoArticleHistoryApi = {
  addHistoryEntry: (entry) => multiApiClient.post("/otto/history/", entry),

  updateHistoryEntry: (id, entry) =>
    multiApiClient.put(`/otto/history/${id}`, entry),

  deleteHistoryEntry: (id) => multiApiClient.delete(`/otto/history/${id}`),

  getPricingHistory: (sku) =>
    multiApiClient.get(`/otto/history/sku/${encodeURIComponent(sku)}`),

  getLatestHistory: (sku) =>
    multiApiClient.get(`/otto/history/sku/latest/${encodeURIComponent(sku)}`),
};

// ── Otto Margin Rules ────────────────────────────────────────────────────────
export const OttoMarginRulesApi = {
  getMarginRules: () => multiApiClient.get("/otto/margin_rules/"),

  getMarginRule: (ruleId) => multiApiClient.get(`/otto/margin_rules/${ruleId}`),

  findByBuyPrice: (buyPrice) =>
    multiApiClient.get(`/otto/margin_rules/find_by_buy_price/${buyPrice}`),

  createMarginRule: (rule) => multiApiClient.post("/otto/margin_rules/", rule),

  updateMarginRule: (ruleId, rule) =>
    multiApiClient.put(`/otto/margin_rules/${ruleId}`, rule),

  deleteMarginRule: (ruleId) =>
    multiApiClient.delete(`/otto/margin_rules/${ruleId}`),
};

// Alias kept for backward compatibility
export const ottoMonitoringApi = {
  startCronJob: (schedule, discord_webhook, sync) =>
    ottoItemsApi.startCronJob(schedule, discord_webhook, sync),
  stopCronJob: () => ottoItemsApi.stopCronJob(),
  getCronStatus: () => ottoItemsApi.getCronStatus(),
};
